module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/base/base-datatable/base-datatable.component.scss
// module id = ./src/app/pages/base/base-datatable/base-datatable.component.scss
// module chunks = main